(function() {
    'use strict';

    angular
        .module('ccsTrApp')
        .controller('PlannedShipmentDeleteController',PlannedShipmentDeleteController);

    PlannedShipmentDeleteController.$inject = ['$uibModalInstance', 'entity', 'PlannedShipment'];

    function PlannedShipmentDeleteController($uibModalInstance, entity, PlannedShipment) {
        var vm = this;

        vm.plannedShipment = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            PlannedShipment.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();
